export default "__VITE_ASSET__FNkEzmWP__"